import { Link } from "react-router-dom";
import React, { useState, useContext } from "react";
import { useToasts } from "react-toast-notifications";

import { HotelServiceContext } from "../../contexts/HotelServiceContext";
import { GUEST_REQ_TYPE, SERVICE_TYPE } from "../../constants";

import { DynamicRoutes } from "../../constants/routes";
import { useTranslation } from "react-i18next";
import { getValue } from "../../utils/object";

export default function Index() {
  const { submitGuestRequest } = useContext(HotelServiceContext);
  const { addToast } = useToasts();
  const { t } = useTranslation();
  const translation = t("services");

  const [inputIssue, setInputIssue] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [isSubmitted, setIsSubmitted] = useState(false);
  const handleInputIssueChange = (e) => setInputIssue(e.target.value);

  const sendGuestRequest = (payload) => {
    setIsSubmitting(true);
    submitGuestRequest(payload)
      .then(() => {
        setIsSubmitted(true);
      })
      .catch(() => {
        addToast("Internal server error!", {
          autoDismiss: true,
          appearance: "error",
        });
      })
      .finally(() => setIsSubmitting(false));
  };

  const handleFormSubmit = (e) => {
    e.preventDefault();
    const payload = {
      details: inputIssue,
    };
    payload.type = GUEST_REQ_TYPE.FRONT_OFFICE;
    payload.requestType = SERVICE_TYPE.REPORT_ISSUE;
    return sendGuestRequest(payload);
  };

  return (
    <>
      <section className="message_area">
        <div className="container">
          <div className="row">
            <div className="col-xl-6 offset-xl-3 col-lg-8 offset-lg-2 col-md-10 offset-md-1">
              <div className="message_box">
                <h1>{getValue(translation, "requestMaintenance.title")}</h1>
                {isSubmitted ? (
                  <div>
                    <div className="report_message_box ha_button">
                      <p>
                        {getValue(translation, "requestMaintenance.successMsg")}
                      </p>

                      <Link to={DynamicRoutes.Services}>
                        {getValue(translation, "requestMaintenance.goBack")}
                      </Link>
                    </div>
                  </div>
                ) : (
                  <>
                    <p>
                      {getValue(translation, "requestMaintenance.description")}
                    </p>
                    <form onSubmit={handleFormSubmit}>
                      <div className="message_input ha_login_input">
                        <textarea
                          name="inputIssue"
                          placeholder={getValue(
                            translation,
                            "requestMaintenance.placeholder"
                          )}
                          rows={10}
                          value={inputIssue}
                          onChange={handleInputIssueChange}
                          required
                        />
                      </div>
                      <div className="ha_button mssg_button">
                        <input
                          type="submit"
                          value={getValue(
                            translation,
                            "requestMaintenance.requestBtn"
                          )}
                          readOnly
                          disabled={isSubmitting || !inputIssue.trim().length}
                        />
                      </div>
                    </form>
                  </>
                )}
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}
